import React from 'react'
import styles from './buttonizedInput.module.scss'

const ButtonizedInput = ({ label, placeholder, value = [], onClick }) => {
  return (
    <div>
      {label}
      <div className={styles.inputContainer} onClick={onClick}>
        {value.length > 0
          ? (
            <div className={styles.value}>
              {value.join(', ')}
            </div>
            )
          : (
            <div className={styles.placeholder}>
              {placeholder}
            </div>
            )}
      </div>
      {value.length > 0 && <div className={styles.inputFooter}>{value.length} selected</div>}
    </div>

  )
}

export default ButtonizedInput
